module.exports = __webpack_public_path__ + "static/mobile-phone4.7d088720.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/connect/mobile-phone4.png
// module id = 195
// module chunks = 68530290604204 153456355441848